<button
  type="button"
  class="med_header-icon-btn med_bell-btn position-relative"
  [attr.aria-label]="'notifications' | translate"
  data-cy="med_header_notifications_trigger"
  (click)="toggle($event)"
>
  <app-icon icon="bell" class="icon-light" />
  @if (notificationsService.hasUnread()) {
    <span class="med_unread-dot position-absolute" data-cy="med_header_notifications_dot"></span>
  }
</button>

<ng-template #panel>
  <div class="med_notifications-panel" data-cy="med_notifications_panel">
    <div class="med_notifications-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <p class="xl-body bold m-0">{{ "notifications" | translate }}</p>
        @if (notificationsService.unreadCount() > 0) {
          <span class="med_unread-badge">
            {{ "notifications_new" | translate: { count: notificationsService.unreadCount() } }}
          </span>
        }
      </div>
      @if (notificationsService.hasUnread()) {
        <button type="button" class="btn btn-link m-body medium p-0" (click)="markAllRead()">
          {{ "mark_all_read" | translate }}
        </button>
      }
    </div>

    <div class="med_notifications-list">
      @for (notification of notificationsService.notifications(); track notification.id) {
        <!-- Rows are not interactive yet: notifications carry no link target
             until the API defines one. -->
        <div class="med_notification-row d-flex gap-3" [class.med_unread]="!notification.read">
          @if (notification.actor) {
            <p-avatar
              [style]="{ 'background-color': notification.actor.name | hexColor }"
              shape="circle"
              [label]="notification.actor.initials"
              class="med_user-circle flex-shrink-0"
            >
            </p-avatar>
          } @else {
            <span class="med_notification-tile d-flex align-items-center justify-content-center flex-shrink-0">
              <app-icon [icon]="notification.kind === 'ai_activity' ? 'arrow-search' : 'align-left'" />
            </span>
          }

          <div class="flex-grow-1">
            <p class="m-body m-0">
              @for (segment of notification.body; track $index) {
                @if (segment.strong) {
                  <b>{{ segment.text }}</b>
                } @else {
                  <span>{{ segment.text }}</span>
                }
              }
            </p>
            <p class="s-body secondary-color m-0">{{ notification.createdAt | timeago }}</p>
          </div>

          @if (!notification.read) {
            <span class="med_row-dot flex-shrink-0"></span>
          }
        </div>
      } @empty {
        <div class="med_notifications-empty d-flex flex-column align-items-center justify-content-center gap-2">
          <app-icon icon="bell" />
          <p class="m-body secondary-color m-0">{{ "no_notifications" | translate }}</p>
        </div>
      }
    </div>
  </div>
</ng-template>

<p-popover #op styleClass="med_header-popover">
  <ng-container *ngTemplateOutlet="panel"></ng-container>
</p-popover>
